import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { fromEvent, map, Observable, throttleTime } from 'rxjs';
import { slide } from './scroll-top.component.animations';

@Component({
    selector: 'lui-scroll-top',
    templateUrl: './scroll-top.component.html',
    styleUrls: ['./scroll-top.component.scss'],
    animations: [slide],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ScrollTopComponent {
  @Input() offset!: number;
  @Output() scrolled: EventEmitter<void> = new EventEmitter();

  isVisible$: Observable<boolean> = fromEvent(window, 'scroll').pipe(
    throttleTime(100),
    map(() => window.scrollY > this.offset)
  );

  constructor(private readonly viewportScroller: ViewportScroller) {}

  scrollTop(): void {
    this.viewportScroller.scrollToPosition([0, 0]);
    this.scrolled.emit();
  }
}
